import React, { useCallback, useMemo, useRef } from 'react';
import classnames from 'classnames';
import { Selection } from '@leverege/ui-redux';
import { List, Dialogs } from '@leverege/ui-elements';
import { ContextMenu, Toolbar, TouchToolbarFactory } from '@leverege/ui-plugin';
import { DataSources, ItemCard } from '@leverege/ui-attributes';
import I18N from '@leverege/i18n';
import LoadingScreen from "../../screens/support/LoadingScreen.js";
import S from './ListView.css';
import { jsx as _jsx } from "react/jsx-runtime";
const noop = () => {};
const {
  t
} = I18N.ns('molten.dataViewers.list.ListView');
export default function ListView(props) {
  const {
    settings,
    rolloverKey,
    rollover,
    selector,
    onOver = noop,
    onOut = noop,
    onClick = noop,
    // onContext = noop,
    paginator,
    loading,
    context,
    matchContext,
    selected,
    relationship: {
      path
    },
    objectType,
    noDataMessage = t('noData')
  } = props;
  const touchToolbarFactory = useRef(new TouchToolbarFactory()).current;
  const showPopup = (event, props) => {
    const position = {
      left: `${event.clientX}px`,
      top: `${event.clientY}px`
    };
    Dialogs.show({
      component: ContextMenu,
      props: {
        position,
        ...props,
        hideWhenEmpty: false
      }
    });
  };
  const onContext = useCallback((e, item) => {
    e.preventDefault();
    const target = Selection.isEmpty(selected) ? item.target : selected.items;
    showPopup(e, {
      context: {
        ...context,
        target: DataSources.withData(target)
      },
      matchContext: {
        use: 'contextMenu',
        path,
        objectType
      }
    });
  }, [context, matchContext]);
  const fData = useMemo(() => {
    return paginator.pageItems.filter(item => item != null);
  }, [paginator.pageItems]);
  const contextItems = useMemo(() => {
    return fData.map(item => {
      if (item == null) {
        return null;
      }
      return {
        id: item.id,
        target: [item]
      };
    });
  }, [fData]);
  if (loading) {
    return /*#__PURE__*/_jsx(CenterScreen, {
      children: /*#__PURE__*/_jsx(LoadingScreen, {
        title: t('loading')
      })
    });
  }
  if (contextItems.length === 0) {
    return /*#__PURE__*/_jsx(CenterScreen, {
      children: noDataMessage
    });
  }
  return /*#__PURE__*/_jsx(List, {
    variant: "detailItem",
    onClick: onClick,
    selector: selector,
    children: contextItems.map(item => {
      return /*#__PURE__*/_jsx(ListItem, {
        factory: touchToolbarFactory,
        context: context,
        item: item,
        model: settings,
        onOver: onOver,
        onOut: onOut,
        onContext: onContext,
        rolloverKey: rolloverKey,
        rollover: rollover,
        path: path,
        objectType: objectType
      }, item.id);
    })
  });
}
ListView.CLIENT = 'ListDataViewer';
function ListItem(props) {
  const {
    model,
    item,
    onOver,
    onOut,
    onContext,
    rolloverKey,
    rollover,
    context,
    factory,
    path,
    objectType,
    ...rest
  } = props;
  const isRolledOver = Selection.isSelected(rollover, item.id);
  const mobilePostfix = context?.clientProps?.mobile === true ? 'Mobile' : '';
  const headerControls = /*#__PURE__*/_jsx(Toolbar, {
    variant: `itemBar${mobilePostfix}|itemBar`,
    hasContextMenu: true,
    context: {
      ...context,
      target: item.target
    },
    matchContext: {
      use: `itemBar${mobilePostfix}`,
      client: ListView.CLIENT,
      path,
      objectType
    },
    prefer: "icon"
  }, "headerToolbar");
  const footerControls = /*#__PURE__*/_jsx(Toolbar, {
    variant: `footerItemBar${mobilePostfix}|footerItemBar|itemBar${mobilePostfix}|itemBar`,
    hasContextMenu: true,
    context: {
      ...context,
      target: item.target
    },
    factory: factory,
    matchContext: {
      use: `itemBar${mobilePostfix}`,
      client: ListView.CLIENT,
      path,
      objectType
    },
    prefer: "icon"
  }, "footerToolbar");
  return /*#__PURE__*/_jsx(List.Item, {
    className: classnames(S.listItem, isRolledOver && S.rollover),
    item: item.target[0],
    ...rest,
    onMouseEnter: () => {
      onOver(item);
    },
    onMouseLeave: () => {
      onOut();
    },
    onContextMenu: evt => {
      onContext(evt, item);
    },
    children: /*#__PURE__*/_jsx(ItemCard, {
      headerControls: headerControls,
      footerControls: footerControls,
      model: model,
      context: item
    })
  });
}
function CenterScreen(props) {
  const {
    children
  } = props;
  return /*#__PURE__*/_jsx("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%'
    },
    children: children
  });
}